import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { BookingProvider } from './contexts/BookingContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Villa from './pages/Villa';
import Booking from './pages/Booking';
import Location from './pages/Location';
import Reviews from './pages/Reviews';
import AdminDashboard from './pages/AdminDashboard';
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <Router>
          <div className="min-h-screen bg-primary-50">
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="villa" element={<Villa />} />
                <Route path="booking" element={<Booking />} />
                <Route path="location" element={<Location />} />
                <Route path="reviews" element={<Reviews />} />
                {/* <Route path="admin" element={<AdminDashboard />} /> */}
              </Route>
            </Routes>
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#6b4f2d',
                  color: '#f5efe4',
                  fontFamily: 'Inter, sans-serif',
                },
              }}
            />
          </div>
        </Router>
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;